import { ThemeProvider } from '@mui/material'
import { styled } from '@mui/material/styles'
import { wrapUseRoutes } from '@sentry/react'
import { MaterialDesignContent, SnackbarProvider } from 'notistack'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useRoutes } from 'react-router'
import GlobalStyles from './components/global/GlobalStyles'
import useScrollReset from './hooks/useScrollReset'
import useSettings from './hooks/useSettings'
import './i18n'
import routes from './routes'
import { createTheme } from './theme'

const useRoutesWSentry = wrapUseRoutes(useRoutes)

const WarningSnackbar = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent-warning': {
    color: theme.palette.common.black,
  },
}))

export default function App() {
  useScrollReset()
  const content = useRoutesWSentry(routes)
  const { settings } = useSettings()
  const { t } = useTranslation()

  const theme = useMemo(
    () =>
      createTheme({
        direction: settings.direction,
        responsiveFontSizes: settings.responsiveFontSizes,
        roundedCorners: settings.roundedCorners,
        theme: settings.theme,
        labelRowsPerPage: t('common.pagination.rowsPerPage'),
      }),
    [
      settings.direction,
      settings.responsiveFontSizes,
      settings.roundedCorners,
      settings.theme,
      t,
    ]
  )

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        Components={{
          warning: WarningSnackbar,
        }}
        dense
        maxSnack={3}
        style={{ fontFamily: theme.typography.fontFamily }}
      >
        <GlobalStyles />
        {content}
      </SnackbarProvider>
    </ThemeProvider>
  )
}
